import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter} from 'react-router-dom';
import './index.css';
import App from './components/app/App';
import reportWebVitals from './reportWebVitals';
ReactDOM.hydrate(
  <BrowserRouter>
    <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-P7FCGV9"
      height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
     <App />
    
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

